<template>
  <div class="navbar">
    <!--    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />-->

    <!--    <breadcrumb class="breadcrumb-container" />-->

    <div class="right-menu">
      <div class="nav-img" @dblclick='changeHostURLShow = true'>
<!--        <img src="@/assets/images/logo.png" alt="" />-->
        <div>真会采销售单打印</div>
      </div>
<!--      <div style="display: flex;align-items: center;">
        <div class="update">
&lt;!&ndash;          <el-popover&ndash;&gt;
&lt;!&ndash;            placement="bottom"&ndash;&gt;
&lt;!&ndash;            width="200"&ndash;&gt;
&lt;!&ndash;            trigger="hover"&ndash;&gt;
&lt;!&ndash;            content="此图标点亮表示跳转到数据大屏">&ndash;&gt;
&lt;!&ndash;            <img slot="reference" src="../../assets/images/back_data.png" style="width: 25px;height: 25px" alt="" @click="godata">&ndash;&gt;
&lt;!&ndash;          </el-popover>&ndash;&gt;
          <img slot="reference" src="../../assets/images/back_data.png" style="width: 25px;height: 25px" alt="" @click="godata">
          <el-popover
            placement="bottom"
            width="200"
            trigger="click"
            content="此图标点亮表示工控机与云端正常连接">
            <i slot="reference" class="el-icon-cloudy" style="font-size: 25px;font-weight: bold;margin-left: 20px;color: #3553ba;"></i>
          </el-popover>
          <el-popover
            placement="bottom"
            width="200"
            trigger="click"
            content="此图标点亮表示工控机的串口链接正常">
            <i slot="reference" class="el-icon-link" style="font-size: 25px;font-weight: bold;margin-left: 20px;color: #3553ba;"></i>
          </el-popover>
          <el-badge  :value="1" class="item">
            <i class="el-icon-bell" style="font-size: 25px;font-weight: bold;margin-left: 20px;color: #3553ba;"></i>
          </el-badge>
        </div>

        <div class="nav-user">
          <img src="@/assets/images/user.png" alt="" />
          <div class="nav-user-name">{{ $store.state.user.name || '暂无登录' }}</div>
          <el-popover
            placement="top"
            width="160"
            v-model="loginOutConfirm">
            <p>是否确认退出登录 ?</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="loginOutConfirm = false">取消</el-button>
              <el-button type="primary" size="mini" @click="loginOut">确定</el-button>
            </div>
            <img slot="reference" alt="退出登录" src="@/assets/images/exit.png"
                 style="width: 40px; height: 40px; cursor: pointer;"/>
          </el-popover>

        </div>
      </div>-->
    </div>

    <el-dialog
      title="修改密码"
      :close-on-click-modal="false"
      :visible.sync="updatePwdDialog"
      :modal-append-to-body="false"
    >
      <div class="msgDiv">
        <el-form ref="form" :model="updatePwdForm" label-width="100px">
          <el-form-item label="旧密码" :required="true">
            <el-input
              type="password"
              show-password
              v-model="updatePwdForm.old_password"
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" :required="true">
            <el-input
              type="password"
              show-password
              v-model="updatePwdForm.new_password"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="再次输入" :required="true">
            <el-input
              type="password"
              show-password
              v-model="updatePwdForm.repass"
              placeholder="请再次输入密码"
            ></el-input>
          </el-form-item>
          <div style="text-align: center">
            <el-button
              :loading="updatePwdBtnLoading"
              type="primary"
              @click="changePassword"
              >提交修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="updateDialog"
      :append-to-body="true"
      :show-close="false"
    >
      <div>
        <div class="update_dialog">
          <div class="update_dialog_left">
          <div style="margin-bottom: 20px;">
            <span style="margin: 0 20px;margin-right: 100px;font-size: 16px;"> 配置更新</span>
          <el-badge style="position: relative;top: 5px;" class="mark" :value="1" />
          </div>
          <div style="margin-bottom: 20px;">
            <span style="margin: 0 20px;margin-right: 100px;font-size: 16px;"> 软件更新</span>
          <el-badge style="position: relative;top: 5px;" class="mark" :value="1" />
          </div>
          </div>
          <div class="update_dialog_rigth">
            <div style="display:flex;justify-content: space-between;align-items: center;">
              <div style="font-weight: bold;color: #000;">有更新项目</div>
              <el-button>现在更新</el-button>
            </div>
            <div>
              <div style="margin-button:5px">_新增广告</div>
              <div style="margin-button:5px">_新增设备</div>
              <div style="margin-button:5px">_新增区域</div>
            </div>

            <div style="font-size: 14px;color:#3553ba ;margin-top: 20px;">
              更多信息 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div style="text-align: center;margin-top: 20px;">
          <i style="font-size: 25px;font-weight: bold;" class="rz-icon rz-icon-cancel" @click="updateDialog=false"></i>
        </div>

      </div>
    </el-dialog>

    <el-dialog :visible.sync="changeHostURLShow" :append-to-body="true">
      <div style="line-height: 60px;display: flex;flex-direction: column;align-items: center">
        <div style="width: 50%">
          <el-input v-model="host_url" placeholder="请输入接口请求域名" size="medium" clearable />
        </div>
        <div style="width: 50%">
          <el-input v-model="port_val" placeholder="请输入端口号"/>
        </div>
      </div>
      <div slot='footer' style="text-align: center;">
        <el-button size='small' type="primary" @click="changeHostURL">点击修改</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { changePassword } from "@/api";
import {getToken} from "@/utils/auth";
import {FetchHostURL} from '@/utils/fetchHostURL'
import {DEVICE_SOCKET_URL, DEVICE_HTTP_URL} from '@/config/config'

export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "name"]),
  },
  data() {
    return {
      updatePwdDialog: false,
      updatePwdForm: {
        old_password: "",
        new_password: "",
        repass: "",
      },
      updatePwdBtnLoading: false,
      loginOutConfirm: false,

      lastTime: null, //鼠标最后一次点击的时间
      currenTime: null, //当前的时间
      timer: null, //定时器
      sys_timeout:10*60 * 1000, //系统安全时间
      check_time: 30 * 1000, //探测时间间隔
      updateDialog:false,
      admin_token:'',
      changeHostURLShow: false,
      hostInstance: null,
      host_url: '',
      port_val: '',
    };
  },
  mounted() {
    this.hostInstance = new FetchHostURL()
    console.log(this.hostInstance, 'fff')
    this.host_url = this.hostInstance.host_url
    this.port_val = this.hostInstance.port_val
    // console.log(DEVICE_SOCKET_URL, DEVICE_HTTP_URL);

    this.admin_token= localStorage.getItem("admin_token")
    this.currenTime = new Date().getTime();
    this.lastTime = new Date().getTime();
    // console.log(this.currenTime, this.lastTime);
    //监听鼠标最后一次点击的事件
    window.document.onmousedown = (event) => {
      this.lastTime = new Date().getTime();
    };
    this.timer = window.setInterval(this.checkTimeOut, this.check_time);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    godata(){
      this.$router.push({path:'/'})
    },
    toggleSideBar() {
      // this.$store.dispatch('app/toggleSideBar')
    },
    async loginOut() {
      this.loginOutConfirm = false
      await this.$store.dispatch("user/loginOut");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },

    showUpdatePwdDialog() {
      this.updatePwdDialog = true;
      this.updatePwdForm.old_password = "";
      this.updatePwdForm.new_password = "";
      this.updatePwdForm.repass = "";
    },

    async changePassword() {
      try {
        this.updatePwdBtnLoading = true;
        const res = await this.$api.changePassword(this.updatePwdForm);
        if (res.data.level === "success") {
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.updatePwdBtnLoading = false;
      }
    },

    checkTimeOut() {
      this.currenTime = new Date().getTime();
      if (this.currenTime - this.lastTime > this.sys_timeout) {
        // if (this.admin_token!='') {
        //   window.localStorage.removeItem('admin_token')
        //   // this.loginOut()
        // } else {
        //   return;
        // }
      }
    },

    changeHostURL() {
      this.hostInstance.setLocalHostURL(this.host_url, this.port_val)
      setTimeout(() => {
        window.location.reload()
        this.$message.success('保存成功 !')
        this.changeHostURLShow = false
      }, 300);
    },

  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 80px;
  overflow: hidden;
  position: relative;
  background: #fff;
  border: 1px solid rgb(235, 235, 235);
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }
}
.right-menu {
  display: flex;
  background: #f5f5fa;
  padding: 20px 30px;
  border-radius: 5px;
  justify-content: space-between;

  .nav-img {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      width: 60px;
      height: 40px;
      object-fit: contain;
    }
    div {
      font-weight: bold;
      font-size: 18px;
      margin-left: 20px;
    }
  }

  .nav-user {
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
    }
    .nav-user-name {
      background: #dfe3f6;
      color: #474b5a;
      padding: 5px 30px;
      border-radius: 25px;
      margin: 0 40px;
    }
  }
}
.update{
  display: flex;
  align-items: center;
  padding: 5px 10px;
  margin-right: 50px;
  cursor: pointer;
}
.update_dialog{
  display: flex;
  .update_dialog_left{
    width:25%;
    background-color:#f2f2f2 ;
    padding: 50px 10px;
    border-radius: 10px;
  }

  .update_dialog_rigth{
    background-color:#f2f2f2 ;
    padding:  20px;
    border-radius: 10px;
    margin-left: 20px;
    width: 70%;
    font-size: 18px;
  }
}
</style>
